/* Cãomigo — lógica da página "cinto" (igual à do Claude Design). Precisa de cmg-dc.js antes. */
(function () {
class Component extends DCLogic {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.state || {}, {
      img: 0, open: {}, cart: 0, added: false, par: false, bump: false, menu: false,
      seen: {}, armed: false, bar: false, live: '', hint: true
    }, this.demoState());
    var self = this;
    this.setRoot = function (el) { self.rootEl = el; };
    this.setCv = function (el) { self.cv = el; };
    this.setCta = function (el) { self.ctaEl = el; };
    ['add', 'addPar', 'toggleMenu', 'dmDown', 'dmMove', 'dmUp', 'dmKey', 'tick'].forEach(function (k) { if (self[k]) self[k] = self[k].bind(self); });
    this.rowT = {};
    ["seguranca", "caixa", "envio"].forEach(function (id) { self.rowT[id] = function () { self.toggle(id); }; });
    this.picks = [0, 1, 2, 3].map(function (i) { return function () { self.setState({ img: i }); }; });
    this.GAL = [{"t": "Em uso.", "d": "Sentado no banco de trás, preso ao arnês. Quem conduz não tem de olhar para trás.", "alt": "Cão calmo no banco de trás, preso pelo cinto de passeio, com o dono ao volante."}, {"t": "No lugar.", "d": "A lingueta no encaixe do cinto, o tirante até às costas do arnês.", "alt": "Cão sentado no banco, com arnês de peito e cinto de passeio."}, {"t": "O mosquetão.", "d": "Giratório, na argola das costas do arnês de peito.", "alt": "Detalhe do mosquetão preso à argola das costas do arnês."}, {"t": "A lingueta e o elástico.", "d": "Entra no encaixe do cinto de segurança. A secção elástica amortece.", "alt": "Lingueta no encaixe do cinto de segurança e secção elástica do tirante."}];
    this.dv = {};
    this.demoInit();
  }

  /* ---------- UI ---------- */
  toggle(id) { var o = Object.assign({}, this.state.open); o[id] = !o[id]; this.setState({ open: o }); }
  toggleMenu() { this.setState({ menu: !this.state.menu }); }
  add() {
    var self = this;
    this.setState({ cart: this.state.cart + 1, added: true, bump: true, live: "Cinto de passeio para o carro adicionado ao carrinho." });
    clearTimeout(this._tA); clearTimeout(this._tB);
    this._tA = setTimeout(function () { self.setState({ added: false }); }, 1800);
    this._tB = setTimeout(function () { self.setState({ bump: false }); }, 460);
  }
  addPar() {
    if (this.state.par) return;
    var self = this;
    this.setState({ cart: this.state.cart + 1, par: true, bump: true, live: "Capa de banco traseiro adicionada ao carrinho." });
    clearTimeout(this._tB);
    this._tB = setTimeout(function () { self.setState({ bump: false }); }, 460);
  }

  componentDidMount() {
    var self = this;
    this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var root = this.rootEl;
    var scrolls = document.documentElement.scrollHeight > (window.innerHeight || 0) + 80;
    if (root && scrolls && 'IntersectionObserver' in window && !this.reduce) {
      var vh = window.innerHeight || 800, seen = {};
      var els = root.querySelectorAll('[data-rv]');
      this.io = new IntersectionObserver(function (es) {
        var add = {}, n = 0;
        es.forEach(function (e) { if (e.isIntersecting) { add[e.target.getAttribute('data-rv')] = true; self.io.unobserve(e.target); n++; } });
        if (n) self.setState(function (s) { return { seen: Object.assign({}, s.seen, add) }; });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.top < vh * 0.92) seen[els[i].getAttribute('data-rv')] = true; else this.io.observe(els[i]);
      }
      this.setState({ seen: seen, armed: true });
    }
    if (this.ctaEl && 'IntersectionObserver' in window) {
      this.io2 = new IntersectionObserver(function (es) {
        var e = es[0]; var off = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (off !== self.state.bar) self.setState({ bar: off });
      }, { threshold: 0 });
      this.io2.observe(this.ctaEl);
    }
    this.setupCv();
  }
  componentWillUnmount() {
    if (this.io) this.io.disconnect();
    if (this.io2) this.io2.disconnect();
    if (this.ro) this.ro.disconnect();
    if (this.onWin) window.removeEventListener('resize', this.onWin);
    if (this.raf) cancelAnimationFrame(this.raf);
    var tw = this._tw || {}; for (var k in tw) cancelAnimationFrame(tw[k]);
    clearTimeout(this._tA); clearTimeout(this._tB);
  }

  /* ---------- palco do momento de assinatura ---------- */
  ease(x) {
    var x1 = .22, y1 = .61, x2 = .36, y2 = 1, t = x;
    for (var i = 0; i < 7; i++) {
      var bx = 3 * x1 * t * (1 - t) * (1 - t) + 3 * x2 * t * t * (1 - t) + t * t * t - x;
      var d = 3 * x1 * (1 - t) * (1 - t) + 6 * (x2 - x1) * t * (1 - t) + 3 * (1 - x2) * t * t;
      if (Math.abs(d) < 1e-6) break; t = Math.max(0, Math.min(1, t - bx / d));
    }
    return 3 * y1 * t * (1 - t) * (1 - t) + 3 * y2 * t * t * (1 - t) + t * t * t;
  }
  tween(key, to, ms, done) {
    var self = this, from = this.dv[key], tw = (this._tw = this._tw || {});
    cancelAnimationFrame(tw[key]);
    if (this.reduce || from === to) { this.dv[key] = to; this.changed(); if (done) done(); return; }
    var t0 = 0;
    var f = function (now) {
      if (!t0) t0 = now;
      var k = Math.min(1, (now - t0) / ms);
      self.dv[key] = from + (to - from) * self.ease(k); self.changed();
      if (k < 1) tw[key] = requestAnimationFrame(f); else if (done) done();
    };
    tw[key] = requestAnimationFrame(f);
  }
  stopTween(key) { var tw = this._tw || {}; cancelAnimationFrame(tw[key]); }
  changed() { this.kick(); this.status(); }
  kick() { if (!this.raf) this.raf = requestAnimationFrame(this.tick); }
  tick() { this.raf = 0; this.draw(); }
  setupCv() {
    var cv = this.cv; if (!cv || !cv.getContext) return;
    this.ctx = cv.getContext('2d');
    var self = this;
    this.fit();
    if (window.ResizeObserver) { this.ro = new ResizeObserver(function () { self.fit(); }); this.ro.observe(cv); }
    else { this.onWin = function () { self.fit(); }; window.addEventListener('resize', this.onWin); }
    this.status();
  }
  fit() {
    var cv = this.cv; if (!cv) return;
    var w = cv.clientWidth, h = cv.clientHeight; if (!w || !h) return;
    var d = Math.min(2, window.devicePixelRatio || 1);
    this.W = w; this.H = h; this.dpr = d;
    cv.width = Math.round(w * d); cv.height = Math.round(h * d);
    var vb = this.VB || [0, 0, this.DW, this.DH], cw = vb[2] - vb[0], ch = vb[3] - vb[1];
    var s = Math.min(w / cw, h / ch);
    this.s = s; this.ox = (w - cw * s) / 2 - vb[0] * s; this.oy = (h - ch * s) / 2 - vb[1] * s;
    this.draw();
  }
  begin() {
    var c = this.ctx; if (!c || !this.W) return null;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.clearRect(0, 0, this.W * this.dpr, this.H * this.dpr);
    c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    c.fillStyle = this.BG; c.fillRect(0, 0, this.W, this.H);
    var d = this.dpr * this.s;
    c.setTransform(d, 0, 0, d, this.dpr * this.ox, this.dpr * this.oy);
    return c;
  }
  scene() { var d = this.dpr * this.s; this.ctx.setTransform(d, 0, 0, d, this.dpr * this.ox, this.dpr * this.oy); }
  label(x, y, txt, o) {
    o = o || {};
    var c = this.ctx, px = this.ox + x * this.s, py = this.oy + y * this.s, fs = o.size || Math.max(12, Math.min(15, 14 * this.s * 1.25));
    c.save(); c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    c.font = (o.weight || 600) + ' ' + fs + 'px Inter, -apple-system, "Segoe UI", sans-serif';
    c.textAlign = o.align || 'center'; c.textBaseline = 'middle';
    if (o.rot) { c.translate(px, py); c.rotate(o.rot); px = 0; py = 0; }
    c.globalAlpha = o.alpha == null ? 1 : o.alpha;
    if (o.bg) {
      var m = c.measureText(txt).width, pw = 7, ph = fs * .72;
      var bx = o.align === 'left' ? px - pw : (o.align === 'right' ? px - m - pw : px - m / 2 - pw);
      c.fillStyle = o.bg; this.rr(c, bx, py - ph, m + pw * 2, ph * 2, 5); c.fill();
    }
    c.fillStyle = o.color || '#2B2A28'; c.fillText(txt, px, py);
    c.restore();
  }
  rr(c, x, y, w, h, r) {
    var rs = typeof r === 'number' ? [r, r, r, r] : r;
    c.beginPath(); c.moveTo(x + rs[0], y); c.lineTo(x + w - rs[1], y); c.quadraticCurveTo(x + w, y, x + w, y + rs[1]);
    c.lineTo(x + w, y + h - rs[2]); c.quadraticCurveTo(x + w, y + h, x + w - rs[2], y + h); c.lineTo(x + rs[3], y + h);
    c.quadraticCurveTo(x, y + h, x, y + h - rs[3]); c.lineTo(x, y + rs[0]); c.quadraticCurveTo(x, y, x + rs[0], y); c.closePath();
  }
  poly(c, pts) { c.beginPath(); c.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) c.lineTo(pts[i][0], pts[i][1]); c.closePath(); }
  quilt(c, x0, y0, x1, y1, step, col) {
    c.save(); c.strokeStyle = col || 'rgba(255,255,255,.075)'; c.lineWidth = 1.2; c.beginPath();
    var h = y1 - y0;
    for (var i = x0 - h; i < x1 + h; i += step) { c.moveTo(i, y0); c.lineTo(i + h, y1); c.moveTo(i, y1); c.lineTo(i + h, y0); }
    c.stroke(); c.restore();
  }
  dim(c, x0, y0, x1, y1, col) {
    c.save(); c.strokeStyle = col || '#6E6961'; c.lineWidth = 1.5; c.beginPath(); c.moveTo(x0, y0); c.lineTo(x1, y1);
    var a = Math.atan2(y1 - y0, x1 - x0), nx = -Math.sin(a) * 7, ny = Math.cos(a) * 7;
    c.moveTo(x0 - nx, y0 - ny); c.lineTo(x0 + nx, y0 + ny); c.moveTo(x1 - nx, y1 - ny); c.lineTo(x1 + nx, y1 + ny); c.stroke(); c.restore();
  }
  pt(e) { var b = this.cv.getBoundingClientRect(); return { x: ((e.clientX - b.left) - this.ox) / this.s, y: ((e.clientY - b.top) - this.oy) / this.s }; }
  cl(v, a, b) { return Math.max(a, Math.min(b, v)); }
  lerp(a, b, t) { return a + (b - a) * t; }
  num(v, d) { return v.toFixed(d == null ? 1 : d).replace('.', ','); }
  noHint() { if (this.state.hint) this.setState({ hint: false }); }
  say(m, alerta) { if (m !== this.state.dmMsg || !!alerta !== !!this.state.dmAlerta) this.setState({ dmMsg: m, dmAlerta: !!alerta, stF: !this.state.stF }); }


  demoState() { return { dmMsg: '', dmAlerta: false, len: 30, at: 'arnes' }; }
  demoInit() {
    this.DW = 800; this.DH = 550; this.BG = '#E3DCCF'; this.VB = [100, 0, 700, 540];
    this.A = { x: 550, y: 436 };
    this.lenT = 30; this.atT = 'arnes';
    this.dv = { r: this.rOf(30), px: 548, py: 350, c: 0 };
    var self = this;
    this.setLen = function (e) { var v = parseInt(e.target.value, 10); if (isNaN(v)) v = 30; self.noHint(); self.lenT = v; self.setState({ len: v }); self.tween('r', self.rOf(v), 300); };
    this.atArnes = function () { self.atT = 'arnes'; self.setState({ at: 'arnes' }); self.tween('c', 0, 350); };
    this.atColeira = function () { self.atT = 'coleira'; self.setState({ at: 'coleira' }); self.tween('c', 1, 350); };
  }
  rOf(v) { return 90 + v * 2.4; }
  dogP() {
    var A = this.A, r = this.dv.r, dx = this.dv.px - A.x, dy = this.dv.py - A.y, d = Math.hypot(dx, dy);
    if (d > r) { this.dv.px = A.x + dx / d * r; this.dv.py = A.y + dy / d * r; }
    this.dv.px = this.cl(this.dv.px, 200, 600); this.dv.py = this.cl(this.dv.py, 150, 400);
    return { x: this.dv.px, y: this.dv.py };
  }
  drawDog(c, P, ct) {
    var x = P.x, y = P.y, fur = '#B58453', furD = '#8F6238';
    c.save();
    c.fillStyle = 'rgba(43,42,40,.13)'; c.beginPath(); c.ellipse(x + 5, y + 30, 36, 60, 0, 0, Math.PI * 2); c.fill();
    c.strokeStyle = furD; c.lineWidth = 8; c.lineCap = 'round'; c.beginPath(); c.moveTo(x, y + 70); c.quadraticCurveTo(x + 6, y + 94, x + 24, y + 98); c.stroke();
    c.fillStyle = furD; c.beginPath(); c.ellipse(x - 25, y + 50, 11, 19, .2, 0, Math.PI * 2); c.ellipse(x + 25, y + 50, 11, 19, -.2, 0, Math.PI * 2); c.fill();
    c.fillStyle = fur; c.beginPath(); c.ellipse(x, y + 24, 29, 50, 0, 0, Math.PI * 2); c.fill();
    c.fillStyle = fur; c.beginPath(); c.ellipse(x, y - 36, 21, 23, 0, 0, Math.PI * 2); c.fill();
    c.fillStyle = furD; c.beginPath(); c.ellipse(x, y - 60, 11, 13, 0, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#2B2A28'; c.beginPath(); c.ellipse(x, y - 70, 5, 4, 0, 0, Math.PI * 2); c.fill();
    c.fillStyle = furD; c.beginPath(); c.ellipse(x - 20, y - 36, 7, 15, .5, 0, Math.PI * 2); c.ellipse(x + 20, y - 36, 7, 15, -.5, 0, Math.PI * 2); c.fill();
    // arnês
    c.strokeStyle = '#2F5D50'; c.lineWidth = 8; c.lineCap = 'round';
    c.beginPath(); c.moveTo(x - 28, y + 6); c.quadraticCurveTo(x, y - 2, x + 28, y + 6); c.stroke();
    c.lineWidth = 6; c.beginPath(); c.moveTo(x, y - 14); c.lineTo(x, y + 2); c.moveTo(x - 17, y - 12); c.quadraticCurveTo(x, y - 20, x + 17, y - 12); c.stroke();
    // coleira
    c.globalAlpha = ct; c.strokeStyle = '#6E6961'; c.lineWidth = 5; c.beginPath(); c.moveTo(x - 17, y - 26); c.quadraticCurveTo(x, y - 32, x + 17, y - 26); c.stroke(); c.globalAlpha = 1;
    c.restore();
  }
  draw() {
    var c = this.begin(); if (!c) return;
    var self = this, A = this.A, r = this.dv.r, ct = this.dv.c;
    var seat = '#CBC2B2', seatD = '#B3A995', seatL = '#D9D1C3';
    c.fillStyle = '#5E5B55'; this.rr(c, 108, -40, 584, 610, 70); c.fill();
    c.fillStyle = '#E8E2D7'; this.rr(c, 126, -22, 548, 572, 56); c.fill();
    var front = function (x) {
      c.fillStyle = seatL; self.rr(c, x, 26, 170, 128, [26, 26, 10, 10]); c.fill(); c.strokeStyle = seatD; c.lineWidth = 2; c.stroke();
      c.fillStyle = seat; self.rr(c, x - 6, 150, 182, 44, 16); c.fill(); c.stroke();
      c.fillStyle = seatD; self.rr(c, x + 55, 180, 60, 20, 8); c.fill();
    };
    front(186); front(444);
    c.fillStyle = '#D3CBBD'; this.rr(c, 372, 40, 56, 170, 14); c.fill();
    var reach = r + 48 > A.y - 194;
    if (reach && ct < .5) { c.save(); c.globalAlpha = .95; c.fillStyle = 'rgba(224,164,94,.22)'; c.strokeStyle = '#E0A45E'; c.lineWidth = 4; this.rr(c, 180, 150, 182, 44, 16); c.fill(); c.stroke(); this.rr(c, 438, 150, 182, 44, 16); c.fill(); c.stroke(); c.restore(); }
    c.fillStyle = seatL; this.rr(c, 164, 300, 472, 142, [22, 22, 8, 8]); c.fill(); c.strokeStyle = seatD; c.lineWidth = 2; c.stroke();
    c.fillStyle = seat; this.rr(c, 156, 436, 488, 64, 18); c.fill(); c.stroke();
    [214, 370, 526].forEach(function (x) { c.fillStyle = seatD; self.rr(c, x, 470, 60, 22, 8); c.fill(); });
    [250, 400, 550].forEach(function (x) { c.fillStyle = '#3A3936'; self.rr(c, x - 9, 424, 18, 24, 4); c.fill(); });
    if (ct < .99) {
      c.save(); c.globalAlpha = 1 - ct; this.rr(c, 126, -22, 548, 572, 56); c.clip();
      c.beginPath(); c.arc(A.x, A.y, r + 48, 0, Math.PI * 2); c.fillStyle = 'rgba(47,93,80,.10)'; c.fill();
      c.setLineDash([7, 6]); c.strokeStyle = '#2F5D50'; c.lineWidth = 1.8; c.stroke(); c.restore();
    }
    var P = this.dogP();
    this.drawDog(c, P, ct);
    var N = { x: P.x, y: P.y - 28 }, E = { x: this.lerp(P.x, N.x, ct), y: this.lerp(P.y, N.y, ct) };
    var dx = E.x - A.x, dy = E.y - A.y, dist = Math.hypot(dx, dy) || 1, slack = Math.max(0, r - dist), sg = Math.min(40, slack * .35);
    var qx = (A.x + E.x) / 2 - dy / dist * sg, qy = (A.y + E.y) / 2 + dx / dist * sg;
    var q = function (tt) { var u = 1 - tt; return { x: u * u * A.x + 2 * u * tt * qx + tt * tt * E.x, y: u * u * A.y + 2 * u * tt * qy + tt * tt * E.y }; };
    c.strokeStyle = '#2B2A28'; c.lineWidth = 5; c.lineCap = 'round'; c.beginPath(); c.moveTo(A.x, A.y); c.quadraticCurveTo(qx, qy, E.x, E.y); c.stroke();
    c.lineWidth = 11; c.strokeStyle = '#3F3E3B'; c.beginPath(); var s0 = q(.35); c.moveTo(s0.x, s0.y);
    for (var i = 1; i <= 14; i++) { var qq = q(.35 + .3 * i / 14); c.lineTo(qq.x, qq.y); } c.stroke();
    c.lineWidth = 1.4; c.strokeStyle = 'rgba(250,247,241,.35)';
    for (i = 0; i <= 14; i++) { var a = q(.35 + .3 * i / 14), b2 = q(.35 + .3 * (i + .5) / 14), ang = Math.atan2(b2.y - a.y, b2.x - a.x) + Math.PI / 2; c.beginPath(); c.moveTo(a.x + Math.cos(ang) * 4.5, a.y + Math.sin(ang) * 4.5); c.lineTo(a.x - Math.cos(ang) * 4.5, a.y - Math.sin(ang) * 4.5); c.stroke(); }
    c.strokeStyle = '#8F8676'; c.lineWidth = 3; c.beginPath(); c.arc(E.x, E.y, 6, 0, Math.PI * 2); c.stroke();
    if (ct > .02) { c.save(); c.globalAlpha = ct; c.strokeStyle = '#E0A45E'; c.lineWidth = 3; c.beginPath(); c.arc(N.x, N.y, 27, 0, Math.PI * 2); c.stroke(); c.restore(); this.label(N.x, N.y - 44, 'pescoço', { bg: '#FAF7F1', alpha: ct }); }
    if (reach && ct < .5) this.label(400, 124, 'chega aqui', { bg: '#FAF7F1' });
  }
  status() {
    var r = this.rOf(this.lenT), m, al = false;
    if (this.atT === 'coleira') { m = 'Nunca à coleira: numa travagem, puxa pelo pescoço. Prende à argola das costas do arnês de peito.'; al = true; }
    else if (r < 125) { m = 'Curto demais: assim não se consegue deitar.'; al = true; }
    else if (r + 48 > this.A.y - 194) { m = 'Comprido demais: chega aos bancos da frente. Encurta.'; al = true; }
    else m = 'Senta-se e deita-se à vontade. Não chega à frente.';
    this.say(m, al);
  }
  dmDown(e) {
    if (!this.W) return; var p = this.pt(e);
    try { this.cv.setPointerCapture(e.pointerId); } catch (x) {}
    this.drag = true; this.off = { x: this.dv.px - p.x, y: this.dv.py - p.y };
    if (Math.hypot(this.off.x, this.off.y) > 110) this.off = { x: 0, y: 0 };
    this.noHint();
  }
  dmMove(e) { if (!this.drag) return; var p = this.pt(e); this.dv.px = p.x + this.off.x; this.dv.py = p.y + this.off.y; this.kick(); }
  dmUp() { this.drag = false; }
  dmKey(e) {
    var k = e.key, s = 14;
    if (k === 'ArrowLeft') this.dv.px -= s; else if (k === 'ArrowRight') this.dv.px += s; else if (k === 'ArrowUp') this.dv.py -= s; else if (k === 'ArrowDown') this.dv.py += s; else return;
    e.preventDefault(); this.noHint(); this.kick();
  }
  demoVals(v) {
    var s = this.state, r = this.rOf(s.len);
    v.setLen = this.setLen; v.lenVal = s.len;
    v.lenTxt = r < 125 ? 'Curto demais' : (r + 48 > this.A.y - 194 ? 'Comprido demais' : 'Na medida');
    v.atArnes = this.atArnes; v.atColeira = this.atColeira;
    v.segA = s.at === 'arnes' ? 'on' : ''; v.segAp = s.at === 'arnes' ? 'true' : 'false';
    v.segC = s.at === 'coleira' ? 'on' : ''; v.segCp = s.at === 'coleira' ? 'true' : 'false';
    return v;
  }


  renderVals() {
    var s = this.state, self = this;
    var gal = {};
    this.GAL.forEach(function (g, i) {
      var on = i === s.img;
      gal['a' + i] = on ? g.alt : ''; gal['c' + i] = on ? 'on' : '';
      gal['t' + i] = on ? 'th sel' : 'th'; gal['p' + i] = on ? 'true' : 'false';
      gal['k' + i] = self.picks[i];
    });
    var cur = this.GAL[s.img];
    var rvc = function (k) { return !s.armed ? '' : (s.seen[k] ? 'rv in' : 'rv'); };
    var o = s.open, rows = {};
    for (var id in this.rowT) { rows[id] = { cls: o[id] ? 'row is-open' : 'row', exp: o[id] ? 'true' : 'false', t: this.rowT[id] }; }
    var v = {
      yes: true, logoH: 40, logoFt: 40,
      preco: 15.9, precoPar: 39.9, precoCapa: 39.9, precoRede: 89, precoForra: 54.9, precoCinto: 15.9, precoTaca: 11.9,
      feats: ["Secção elástica que amortece os solavancos", "Mosquetão giratório que não torce o tirante", "Comprimento ajustável: senta-se e deita-se, não chega à frente"],
      trust: [{"icone": "envio", "texto": "Envio grátis"}, {"icone": "devolucao", "texto": "Devolução em 14 dias"}, {"icone": "prazo", "texto": "10 a 15 dias úteis"}],
      specs: [{"rotulo": "Ao carro", "valor": "Lingueta do cinto de segurança"}, {"rotulo": "Amortecimento", "valor": "Secção elástica com bainha sanfonada"}, {"rotulo": "Ao cão", "valor": "Mosquetão giratório, argola das costas do arnês"}, {"rotulo": "Material", "valor": "Nylon com costura refletora"}, {"rotulo": "Comprimento", "valor": "Ajustável pelo regulador"}, {"rotulo": "Não incluído", "valor": "Arnês de peito"}],
      factos: [{"titulo": "Envio grátis", "texto": "Para Portugal e 13 países da UE, sem mínimo."}, {"titulo": "10 a 15 dias úteis", "texto": "Sai de armazém internacional."}, {"titulo": "Devolução em 14 dias", "texto": "Sem justificação. Trocamos ou devolvemos o dinheiro."}, {"titulo": "Resposta em 1 dia útil", "texto": "caomigo.pt@gmail.com"}],
      gal: gal, capT: cur.t, capD: cur.d,
      ctaLabel: s.added ? 'Adicionado ao carrinho' : 'Adicionar ao carrinho',
      ctaShort: s.added ? 'Adicionado' : 'Adicionar ao carrinho', ctaCls: s.added ? 'cta-l on' : 'cta-l', added: s.added,
      parLabel: s.par ? "Capa adicionada" : "Adicionar a capa",
      add: this.add, addPar: this.addPar, liveMsg: s.live,
      hasCart: s.cart > 0, cart: s.cart, bdgCls: s.bump ? 'bdg bump' : 'bdg',
      cartLabel: s.cart > 0 ? 'Carrinho, ' + s.cart + (s.cart === 1 ? ' artigo' : ' artigos') : 'Carrinho, vazio',
      menuExp: s.menu ? 'true' : 'false', toggleMenu: this.toggleMenu, mnavCls: s.menu ? 'mnav is-open' : 'mnav',
      rows: rows,
      rv: { chips: rvc('chips'), foto: rvc('foto'), demo: rvc('demo'), ph: rvc('ph'), passos: rvc('passos'), det: rvc('det'), faq: rvc('faq'), relh: rvc('relh'), rel: rvc('rel'), fac: rvc('fac') },
      setRoot: this.setRoot, setCv: this.setCv, setCta: this.setCta,
      dmDown: this.dmDown, dmMove: this.dmMove, dmUp: this.dmUp, dmKey: this.dmKey,
      dmMsg: s.dmMsg, stCls: (s.dmAlerta ? 'dm-st alerta' : 'dm-st') + (s.stF ? ' f1' : ' f0'), hintCls: s.hint ? 'dm-hint' : 'dm-hint off',
      barCls: s.bar ? 'mbar on' : 'mbar', barHidden: s.bar ? 'false' : 'true'
    };
    return this.demoVals(v);
  }
}
(window.CMG = window.CMG || {}).pages = window.CMG.pages || {};
window.CMG.pages['cinto'] = Component;
if (window.CMG.mountAll) window.CMG.mountAll();
})();
